module.exports = __webpack_public_path__ + "static/flags/HU-cbb976da704721be5b67fb6cf83eed81.gif";